import { CountryData } from 'types/wellGuardian';

import {
  AG_REACTIVE_SCOPE_STEP_KEYS,
  AG_STEP_KEYS,
  AR_REACTIVE_SCOPE_STEP_KEYS,
  AR_STEP_KEYS,
  CG_REACTIVE_SCOPE_STEP_KEYS,
  CG_STEP_KEYS,
  DK_REACTIVE_SCOPE_STEP_KEYS,
  DK_STEP_KEYS,
  IR_REACTIVE_SCOPE_STEP_KEYS,
  IR_STEP_KEYS,
  NG_REACTIVE_SCOPE_STEP_KEYS,
  NG_STEP_KEYS,
  UK_REACTIVE_SCOPE_STEP_KEYS,
  UK_STEP_KEYS,
} from '../wir.constants';

export const getStepKeys = (country: string) => {
  switch (country) {
    case CountryData.denmark:
      return DK_STEP_KEYS;
    case CountryData.nigeria:
      return NG_STEP_KEYS;
    case CountryData.congo:
      return CG_STEP_KEYS;
    case CountryData.angola:
      return AG_STEP_KEYS;
    case CountryData.iraq:
      return IR_STEP_KEYS;
    case CountryData.argentina:
      return AR_STEP_KEYS;
    default:
      return UK_STEP_KEYS;
  }
};

export const getReactiveStepKeys = (country: string) => {
  switch (country) {
    case CountryData.denmark:
      return DK_REACTIVE_SCOPE_STEP_KEYS;
    case CountryData.nigeria:
      return NG_REACTIVE_SCOPE_STEP_KEYS;
    case CountryData.congo:
      return CG_REACTIVE_SCOPE_STEP_KEYS;
    case CountryData.angola:
      return AG_REACTIVE_SCOPE_STEP_KEYS;
    case CountryData.iraq:
      return IR_REACTIVE_SCOPE_STEP_KEYS;
    case CountryData.argentina:
      return AR_REACTIVE_SCOPE_STEP_KEYS;
    default:
      return UK_REACTIVE_SCOPE_STEP_KEYS;
  }
};
